module.exports = __webpack_public_path__ + "static/media/CC5B4C44-92D5-41A1-80BA-4EBD55622AB7-min.15b3d573.jpg";